import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";


function Adminlogin() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const canvasRef = useRef(null);
  const navigate = useNavigate();

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCaptcha = "";
    for (let i = 0; i < 6; i++) {
      randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(randomCaptcha);
    setUserCaptcha("");
    setIsCaptchaValid(false);
    drawCaptcha(randomCaptcha);
  };

  const drawCaptcha = (captchaText) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = "italic bold 30px 'Courier New', monospace";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    for (let i = 0; i < 150; i++) {
      ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        1
      );
    }

    for (let i = 0; i < captchaText.length; i++) {
      const x = 20 + i * 20;
      const y = 20 + Math.random() * 5;
      const angle = (Math.random() - 0.5) * 0.5;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${
        Math.random() * 100
      })`;
      ctx.fillText(captchaText[i], 0, 0);
      ctx.restore();
    }
  };

  const validateCaptcha = (e) => {
    const val = e.target.value;
    setUserCaptcha(val);
    setIsCaptchaValid(val === captcha);
  };

  const handleLoginWithCaptcha = async () => {
    if (!loginId || !password) {
      Swal.fire("Warning", "Please enter Login ID and Password", "warning");
      return;
    }

    if (!isCaptchaValid) {
      Swal.fire({
        icon: "error",
        title: "Invalid CAPTCHA",
        text: "Please enter the correct CAPTCHA.",
        confirmButtonColor: "#d33",
      });
      generateCaptcha();
      return;
    }

    await handleLogin();
    generateCaptcha();
  };

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminLoginClass10`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            logiN_ID: loginId,
            password: password,
          }),
        }
      );

      const data = await response.json();
      // console.log(data);
      if (response.ok) {
        sessionStorage.setItem("tokenadmin", data.data.token);
        // sessionStorage.setItem("loginId", loginId);
        // sessionStorage.setItem("candidatename", data.data.CandidateName);
        // console.log(data);
        navigate("/admin-dashboard");
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <>
      <div className="container-scroller">
        <header className="fixed-top bg-brown">
          <div className="container">
            <div
              className="d-flex align-items-center"
              style={{ margin: "5px 0px" }}
            >
              <img
                src="../assets/images/jac-academic-council.png"
                alt="JAC Logo"
                style={{ height: "70px", marginRight: "15px" }}
                className="banner-img"
              />
              <div>
                <h3
                  className="logo-firsttext text-white"
                  style={{ marginTop: 5 }}
                >
                  Jharkhand Academic Council, Ranchi
                </h3>
                <h4 className="logo-secondtext text-white">
                  Scrutiny Portal 2026
                </h4>
              </div>
            </div>
          </div>
        </header>

        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="container">
              <div className="row w-100">
                <div className="col-md-4"></div>
                <div className="col-lg-4">
                  <div className="auth-form-light text-left py-3 px-3">
                    <h4 className="text-center mb-3">Admin Login</h4>
                    <form className="pt-2" onSubmit={(e) => e.preventDefault()}>
                      <div className="form-group">
                        <h6 className="font-weight-light">Login ID</h6>
                        <input
                          type="text"
                          maxLength={20}
                          className="form-control form-control-xs"
                          placeholder="Enter Your LoginID"
                          value={loginId}
                          onChange={(e) => setLoginId(e.target.value)}
                        />
                      </div>

                      <div className="form-group">
                        <h6 className="font-weight-light">Password</h6>
                        <input
                          type="password"
                          className="form-control form-control-xs"
                          placeholder="Enter Your Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>

                      <div className="form-group mb-3 text-center">
                        <canvas
                          ref={canvasRef}
                          width="140"
                          height="40"
                          style={{ border: "1px solid #ddd" }}
                        />
                        <button
                          type="button"
                          onClick={generateCaptcha}
                          className="btn btn-secondary ms-2"
                          style={{ marginTop: "-33px" }}
                        >
                          ↻ Refresh
                        </button>
                      </div>

                      <div className="form-group">
                        <label className="form-label">Enter CAPTCHA</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter CAPTCHA"
                          value={userCaptcha}
                          onChange={validateCaptcha}
                        />
                      </div>

                      <div className="mt-1">
                        <button
                          type="button"
                          onClick={handleLoginWithCaptcha}
                          className="btn btn-block bg-brown btn-xs text-white"
                          style={{ padding: "10px" }}
                          disabled={loading}
                        >
                          {loading ? "Logging in..." : "Login"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-md-4"></div>
              </div>
            </div>
          </div>
        </div>

        <footer
          className="fixed-bottom bg-brown text-center text-white"
          style={{ padding: "8px 0" }}
        >
          <p style={{ marginBottom: 0, fontSize: "12px" }}>
             Copyright &copy; JAC. All rights reserved.
          </p>
        </footer>
      </div>
    </>
  );
}

export default Adminlogin;